import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
/**
 * 企微配置类型，可按需扩展。
 * 明确逻辑用于什么场景，方便接入cac。
 */
export enum EnterPriseType {
    ALL = 'all', // 适用于所有类型
    APP = 'app', // 任意设备端的企微app
    APP_IPAD = 'app-ipad', // ipad上企微app
    APP_PC = 'app-pc', // pc上的企微app
    MOBILE = 'mobile', // 应用于mobile上的企微
    TENCENTDOC_APP_WEWORK_LOGIN = 'tencentDoc-app-wework-login', // 应用于企微登录的腾讯文档app
    TENCENTDOC_APP_WEWORK_LOGIN_PAD = 'tencentDoc-app-wework-login-pad',
    PC = 'pc', // pc上的企微文档，包括浏览器打开和app
}

/**
 * 获取配置map
 */
const getConfigMap = () => {
    const configMap = new Map();
    const platform = appConfigInstance.getConfig('platform');
    // 之后可以接入cac
    // configMap.set([TitleBarConfig.collapseMenu],
    //     setDefaultConfig(appConfigInstance.getConfig(TitleBarConfig.collapseMenu), true) )
    // 先使用ua判断app，后续接入cac
    if (__IS_WECOM__) {
        configMap.set(EnterPriseType.ALL, true);
        configMap.set(EnterPriseType.APP, browser.isWxWork);
        configMap.set(EnterPriseType.APP_IPAD, browser.isWxWork && browser.isIPad);
        configMap.set(EnterPriseType.APP_PC, browser.isWxWork && browser.isPc);
        configMap.set(EnterPriseType.MOBILE, platform === 'mobile');
        configMap.set(
            EnterPriseType.TENCENTDOC_APP_WEWORK_LOGIN,
            browser.isTencentDocApp,
        );
        configMap.set(
            EnterPriseType.TENCENTDOC_APP_WEWORK_LOGIN_PAD,
            browser.isTencentDocApp && browser.isPad,
        );
        configMap.set(EnterPriseType.PC, platform === 'pc');
    }

    return configMap;
};

const configMap = getConfigMap();

/**
 * 判断是否是企业微信渠道，先写死为true，等配置化接入后，使用配置化来判断是否是企业微信渠道
 */
const config = {
    // 判断名为item的配置企微是否支持
    supportEnterprise: (item: EnterPriseType): boolean => !!configMap.get(item),
};

/**
 * 判断是否是为ipad客户端，包括文档app和企微app
 */
export const isIpadApp = (): boolean => browser.isIpadAndTencentDocApp
    || config.supportEnterprise(EnterPriseType.APP_IPAD);

export default config;
